module.exports = __webpack_public_path__ + "img/icon_muscle.b403b15b.svg";